/* global SideDrawer */

if (!customElements.get('mobile-sort-drawer')) {
  class MobileSortDrawer extends SideDrawer {
    constructor() {
      super();
      this.init();
    }

    init() {
      // Open drawer when toolbar button is clicked
      const openButton = document.querySelector('.js-toggle-mobile-sort');
      if (openButton) {
        openButton.addEventListener('click', (evt) => {
          evt.preventDefault();
          this.open(openButton);
        });
      }

      // Handle sort option selection
      const form = this.querySelector('#mobile-sort-form');
      if (form) {
        form.addEventListener('change', (evt) => {
          if (evt.target.name !== 'sort_by') return;

          const selectedValue = evt.target.value;
          const url = new URL(window.location.href);
          url.searchParams.set('sort_by', selectedValue);

          // Navigate to the new URL to apply sorting
          window.location.href = url.toString();
        });
      }
    }
  }

  customElements.define('mobile-sort-drawer', MobileSortDrawer);
}


